// extracted by mini-css-extract-plugin
export var collapsedSummary = "_op-0";